<template>
  <!-- DQ船运唛头客户授权 -->
  <div>
    <div class="main" v-for="(datas, index) in printData" :key="index">
      <div class="content">
        <div class="title">
          <div>{{ datas.porder_sn.split('-')[0].substr(datas.porder_sn.split('-')[0].length - 4)
            }}-{{ datas.porder_sn.split('-')[1] }}-{{ datas.number }}</div>
          <div>{{ datas.porder.y_admin.username }} {{ datas.porder.p_admin.username }}</div>
        </div>
        <div class="top">
          <div class="top-title" :style="{ fontSize: datas.express_no.length > 13 ? '80px' : '100px' }">{{
      datas.express_no }}</div>
          <div class="top-text">CTNO.{{ datas.number_by_express_no }}/{{ datas.count_by_express_no }}</div>
          <p>MADE IN CHINA</p>
        </div>
        <div class="footer">
          <!-- 订单号 -->
          <div>
            <div class="left">
              <img src="../../assets/dayindanicon/icon1.png" alt="" />
            </div>
            <div class="right lines">
              <!-- 没有原单号 -->
              <div v-if="datas.porder.split_from == '' || datas.porder.from_porder_sn == ''">

                {{ datas.porder_sn }}-{{ datas.number }}
                <!-- FBA授权 -->
                <div v-if="datas.porder.is_fba">
                  {{ datas.porder.importer.company }}
                </div>
              </div>
              <div v-else>

                <p>{{ datas.porder_sn }}-{{ datas.number }}</p>
                <p class="line" v-if="datas.porder.split_from">
                  原单号: {{ datas.porder.split_from }}</p>
                <p class="line" v-if="datas.porder.from_porder_sn">
                  原单号:{{ datas.porder.from_porder_sn }}</p>
                <!-- FBA授权 -->
                <div v-if="datas.porder.is_fba" class="line">
                  {{ datas.porder.user.realname }}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="left">
              <img src="../../assets/dayindanicon/icon2.png" alt="" />
            </div>
            <div class="right">{{ datas.order_box ? datas.order_box.order_sn : '' }} - {{
      datas.order_box ? datas.order_box.box_no : '' }}</div>
          </div>
          <div style="margin-bottom: 84px">
            <div class="left">
              <img src="../../assets/dayindanicon/icon3.png" alt="" />
            </div>
            <div class="right">
              <div>
                <p><span class="size">Weight:</span><span> {{ datas.weight }}</span></p>
                <p><span class="size">Size:</span><span> {{ datas.length }}×{{ datas.width }}×{{ datas.height }}</span>
                </p>
              </div>
            </div>
          </div>
          <!-- 二维码 -->
          <div class="tiaoxingma">
            <canvas :id="'express_no' + index" style="height:240px" />
          </div>
          <div class="txt">{{ datas.express_no }}</div>
          <p class="data">
            担当:{{ datas.porder.y_admin.realname }}
            <span style="margin-left: 20px;">
              配货:{{ datas.porder.p_admin.realname }}
            </span>

            <span class="span">{{ transferDate(new Date()) }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { transferDate } from '@/utlis/date'
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState(
      {
        printData: (state) => state.porderDetail.printData, //要打印的数据
      }
    )

  },
  data() {
    return {
      transferDate
    };
  },
  created() {
    // this.$nextTick(() => {
    //   this.$print(this.$refs.print)
    // })
  },
  mounted() {
    this.printData.forEach((item, index) => {
      this.getJsBarcode("#express_no" + index, item.express_no);
    })
  },
  methods: {

    // 一维码
    getJsBarcode(selector, data) {
      JsBarcode(selector, data, {
        displayValue: true,
        height: 240,
        width: 6,
        margin: 0,
        fontSize: 0,
        displayValue: false,
        lineColor: "#000000",//设置条和文本的颜色。
      });
      this.$forceUpdate();
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 1181px;
  height: 1772px;
  background: #fff;
  padding: 60px;
  box-sizing: border-box;
  color: #000000 !important;

  div {
    box-sizing: border-box;
    font-weight: 600 !important;
  }

  .content {
    width: 1061px;
    height: 1652px;

    border: 8px solid #000000;
    border-top: 0;
    position: relative;
    padding-top: 160px;

    .title {
      position: absolute;
      left: -8px;
      top: 0;
      width: 1061px;
      height: 160px;
      background: #000000;
      text-align: center;
      line-height: 160px;
      font-size: 60px;
      color: #ffffff;
      margin: 0;
      display: flex;
      padding-left: 52px;
      padding-right: 60px;
      justify-content: space-between;
      align-items: center;
    }

    .top {
      height: 386px;
      width: 100%;
      box-sizing: border-box;
      border-bottom: 8px solid #000000;
      padding-top: 20px;
      padding-bottom: 20px;

      .top-title {
        width: 800px;
        height: 150px;
        margin: auto;
        line-height: 150px;
        text-align: center;
        font-size: 100px;
        color: #000000;
        // margin-top: 115px;
        margin-bottom: 20px;
      }

      .top-text {
        width: 600px;
        height: 96px;
        margin: auto;
        height: 96px;
        background: #000000;
        text-align: center;
        font-size: 64px;
        color: #ffffff;
        line-height: 96px;
        margin-bottom: 20px;
      }

      p {
        width: 320px;
        margin: auto;
        height: 60px;
        line-height: 60px;
        font-size: 40px;
        text-align: center;
        color: #000000;
      }
    }

    .footer {
      padding: 60px 60px 30px 60px;

      >div {
        height: 120px;
        display: flex;
        margin-bottom: 40px;

        .left {
          img {
            width: 120px;
            height: 120px;
          }
        }

        .right {
          display: flex;
          height: 120px;
          margin-left: 60px;
          line-height: 120px;
          font-size: 48px;
          color: #000000;

          .line {
            font-size: 38px !important;
            font-weight: 500;
          }



          p {
            height: 60px;
            line-height: 60px;

            span {
              font-size: 48px;
              color: #000000;
            }

            .size {
              font-size: 40px;
              font-weight: 400;
              color: #000000;
              padding-bottom: 10px;
            }
          }
        }

        .lines {
          line-height: 70px !important;
        }
      }

      .tiaoxingma {
        width: 941px;
        height: 240px !important;
        overflow: hidden;

        img {
          width: 941px;
          height: 240px !important;

        }

        margin-bottom: 20px;
      }

      .txt {
        margin: auto;
        width: 941px !important;
        display: flex;
        justify-content: center;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 40px;
        color: #000000;
      }

      .data {
        width: 100%;
        height: 48px;

        line-height: 48px;
        margin-top: 52px;
        font-size: 32px;
        font-weight: 400;
        color: #000000;

        .span {
          float: right;
        }
      }
    }
  }
}
</style>
